import { GloFasForecast } from "config/layer-config"

// const epochs = [2050]
//const adaptations = ['cla', 'ews']
const pop_growths = ['sg', 'ri', 'cg']
const gmst_rises = [15, 30]

const defaultFloodRisks = {
  attributionString: 'Sayers and Partners'
}


const defaultEadtPointValues = {
  ...defaultFloodRisks,
  url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/eth_wb/flood_risks/eadt_point.zip',
  metric: 'eadt_point',
  legend: [
    {text: '0-50,000', color: '#30a524'},
    {text: '50,000-150,000', color: '#e3ea08'},
    {text: '150,000-500,000', color: '#f19203'},
    {text: '> 500,000', color: '#bf0d0d'},
  ]
}


const eadt_marker_popup = (feature, layer, eadt_variable) => {
  layer.bindPopup(`$${Math.round(feature.properties[eadt_variable]).toLocaleString()}`)
}


const eadt_point_style = (feature, latlng, eadt_variable) => {
  const toColor = x => {
    if (x < 50000) return '#30a524';
    if (x < 150000) return '#e3ea08';
    if (x < 500000) return '#f19203';
    return '#bf0d0d';
  }

  const geojsonMarkerOptions = {
    radius: Math.round((feature.properties[eadt_variable]) / 10000000 + (Math.log(feature.properties[eadt_variable])/2)),
    fillColor: toColor(feature.properties[eadt_variable]),
    color: "#000",
    weight: 1,
    opacity: 1,
    fillOpacity: 0.8
  };
  return window.L.circleMarker(latlng, geojsonMarkerOptions);
}

let floodHazards = [
  {
    ...defaultEadtPointValues,
    epoch: 2020,
    title: 'EAD T',
    name: 'pd_ead',
    metric: 'eadt_point',
    pop_growth: false,
    gmst: false,
    pointToLayer: (feature, latlng) => eadt_point_style(feature, latlng, 'pd_ead'),
    onEachFeature: (feature, layer) => eadt_marker_popup(feature, layer, 'pd_ead')
  }
]

// epochs.forEach(epoch => {
//   pop_growths.forEach(pop_growth => {
//     gmst_rises.forEach(gmst => {
//       const future_identifier = pop_growth[0] + '_' + (gmst).toString()
//       const eadt_var = pop_growth + '_' + gmst.toString() + '_ead' // future_identifier + '_ead'


//       floodHazards.push({
//         ...defaultEadtPointValues,
//         name: eadt_var,
//         epoch,
//         pop_growth,
//         gmst,
//         pointToLayer: (feature, latlng) => eadt_point_style(feature, latlng, eadt_var),
//         onEachFeature: (feature, layer) => eadt_marker_popup(feature, layer, eadt_var)

//       })

//     })
//   })
// })


const visibleFloodRisks =  {
  sectionText: 'Flood Risks',
  section: 'floodRisk',
  components: [
    {
      text: 'Epoch',
      type: 'select',
      stateProperty: 'epoch',
      options: [
        {key:1, text: 'PD', value: 2020},
        {key: 2, text: '2030s', value: 2030},
        {key: 3, text: '2070s', value: 2070}
      ],
      initialState: 2020
    },
    {
      text: 'GMST Rise',
      type: 'select',
      stateProperty: 'gmst',
      isVisible: (sectionState => sectionState.epoch === 2050),
      options: [
        {key: 1, text: '15%', value: 15},
        {key: 2, text: '30%', value: 30},
      ]
    },
    {
      text: 'Growth',
      type: 'select',
      stateProperty: 'pop_growth',
      isVisible: (sectionState => sectionState.epoch === 2050),
      options: [
        {key: 1, text: 'CG', value: 'cg'},
        {key: 2, text: 'SG', value: 'sg'},
        {key: 3, text: 'RI', value: 'ri'},
      ],
    },
    {
      text: 'Metric',
      type: 'select',
      stateProperty: 'metric',
      options: [
        {key: 1, text: 'Expected Annual Damage (direct and indirect)', value: 'eadt_point'},
      ],
      initialState: '',
    },
  ]
}


const riskDefaults = {
  pixelValuesToColorFn: (([value]) => {
    if (value > 50) return '#e31a1c';
    if (value > 20) return '#fd8d3c';
    if (value > 5) return '#fecc5c';
    if (value > 0.5) return '#ffffb2';
    return `rgba(0,0,0,0)`;
  }),
  title: 'EAD ($/m2 - 2022 prices)',
  legend: [
    {color: '#ffffb2', text: '0.5 - 5'},
    {color: '#fecc5c', text: '5 - 20'},
    {color: '#fd8d3c', text: '20 - 50'},
    {color: '#e31a1c', text: '> 50'},
  ],
  opacity: 1, 
  zIndex: 420
}


const getRiskUrl = (source, scenario, adaptation) => {

  if (scenario === 'Low') scenario = '2030s, lowclimate, lowerPopSSP2'
  if (scenario === 'High') scenario = '2070s, highclimate, higherPopSSP4'

  const prefix = 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/flood_risks/'
  if (adaptation)
    return prefix +  'ead_' + source + '_' + scenario + '_' + adaptation + '_cogeo.tif'

  return prefix +  'ead_' + source + '_' + scenario + '_cogeo.tif'
}


const Risks = []

let idx = 0

const sources = ['f', 'c', 'sw']

const scenarios = [
  'Present Day',
  'Low',
  'High'
]
const adaptations = ['Reduced','Maintain', 'Enhance']

sources.forEach(source => {
  scenarios.forEach(scenario => {
    
    if (scenario === 'Present Day') {
      Risks.push({
        idx: idx,
        id: idx,
        key: source + '_' + scenario,
        ...riskDefaults,
        name: source + '_' + scenario,
        text: scenario,
        url: getRiskUrl(source, scenario, null),
        source: source,
        scenario: scenario
      })
      idx++;
    }

    if (scenario !== 'Present Day') {
      adaptations.forEach(adaptation => {
        Risks.push({
          idx: idx,
          id: idx,
          key: source + '_' + scenario + '_' + adaptation,
          ...riskDefaults,
          name: source + '_' + scenario + '_' + adaptation,
          text: scenario,
          url: getRiskUrl(source, scenario, adaptation.toLowerCase()),
          source: source,
          scenario: scenario,
          adaptation: adaptation
        })
        idx++;
      })
    }
  }) 
})
  



export default {
  sectionText: 'Flood risks',
  section: 'floodRisk',
  components: [
    {
      text: 'Source',
      type: 'select',
      stateProperty: 'source',
      options: [
        {key:1, text: 'Fluvial', value: 'f'},
        {key: 2, text: 'Coastal', value: 'c'},
        {key: 3, text: 'Surface water', value: 'sw'}
      ],
      initialState: 'f'
    },
    {
      text: 'Flood Scenario',
      type: 'select',
      stateProperty: 'scenario',
      options: scenarios.map(s => {return {key: s, text: s, value: s}}),
      initialState: null
    },
    {
      isVisible: (layers) => { return layers.scenario && layers.scenario !== 'Present Day' },
      text: 'Adaptation',
      type: 'select',
      stateProperty: 'adaptation',
      options: adaptations.map(s => {return {key: s, text: s, value: s}}),
      initialState: null
    },

    {
      text: 'Flood Risk',
      type: 'hidden',
      stateProperty: 'flood_hazard',
      initialState: null,
      layerType: 'select-rasterfile',
      filter: (hazard, sectionState) => {
        if (sectionState.scenario == 'Present Day') {
          return hazard.source == sectionState.source && hazard.scenario == sectionState.scenario
        }
        return (hazard.adaptation == sectionState.adaptation) && (hazard.source == sectionState.source) && (hazard.scenario == sectionState.scenario)

      },
      allOptions: Risks.map(area => ({
        ...area,
        key: area.name,
        id: area.name,
        text: area.text,
        value: area.name
      })),
      rasterfiles: Risks
    },



  ]
}

export {
  floodHazards
}